import React, { createContext, useState, useContext, useEffect } from 'react';
import { BASE_URL } from './conf/config';
import { jwtDecode } from 'jwt-decode';
import { getCookie, setCookie, deleteCookie } from './conf/config';

const UserContext = createContext();

export const UserProvider = ({ children }) => {
    // Global orders
    const [orders, setOrders] = useState([]);
    // Visitor; Admin
    const [userGroups, setUserGroups] = useState([]);
    const [username, setUsername] = useState('');

    // if get token
    const parseTokenAndSetGroups = () => {
        const accessToken = getCookie('access_token');
        if (accessToken) {
            try {
                const decodedToken = jwtDecode(accessToken);
                const groups = decodedToken.groups || [];
		console.log("Decoded JWT Token:", decodedToken);
		console.log("Extracted Groups:", groups);
                setUserGroups(groups);
                setUsername(decodedToken.username || '');
            } catch (error) {
                console.error('Failed to decode token:', error);
            }
        }
    };

    const refreshToken = async () => {
        const refresh_token = getCookie('refresh_token');

        if (!refresh_token) {
            window.location.href = '/login';  // if refresh token is not available, redirect to login page
            return null;
        }

        try {
            const response = await fetch(`${BASE_URL}/api/token/refresh/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ refresh: refresh_token }),  // send refresh token to server
            });

            if (!response.ok) {
                deleteCookie('access_token');
                deleteCookie('refresh_token');
                window.location.href = '/login';
                return null;
            }

            const data = await response.json();
            setCookie('access_token', data.access, 1);  // set access token in cookie
            if (data.refresh) {
                console.log("Refresh token received: ", data.refresh);
                setCookie('refresh_token', data.refresh, 24);  // if there is a refresh token in the response, set it in cookie
            }
            return data.access;
        } catch (error) {
            console.error('Error refreshing access token:', error);
            return null;
        }
    };

    // Fetch data alawy with authentication
    const fetchWithAuth = async (url, options = {}) => {
        let access_token = getCookie('access_token');

        options.headers = {
            ...options.headers,
            'Authorization': `Bearer ${access_token}`,
        };

        try {
            let response = await fetch(url, options);

            if (response.status === 401) {
                // if access token is expired, refresh it and retry the request
                const newAccessToken = await refreshToken();

                if (newAccessToken) {
                    options.headers['Authorization'] = `Bearer ${newAccessToken}`;
                    response = await fetch(url, options);  // retry the request with the new token
                } else {
                    throw new Error("Failed to refresh access token");
                }
            }

            return response;
        } catch (error) {
            console.error('API request failed:', error);
            throw error;
        }
    };

    useEffect(() => {
        parseTokenAndSetGroups();
    }, []);

    const processOrders = (msg) => {
        // extract orders from data
        const orders = msg["data"];
        console.log("msg", msg);
        console.log("add orders to log:", orders);
        let orderString = ""; // string to store orders
    if (orders && Array.isArray(orders)) {
    	if (orders.length > 0) {
            orders.forEach(order => {
            	const orderID = order["order_ID"] || "Unknown";
            	const positionID = order["position_ID"] || "Unknown";
            	orderString += `Order ID: ${orderID}, Position ID: ${positionID}\n`;
    	    });
    	} else {
        	console.log("No orders available, but data is valid.");
    	}
    } else if (orders !== undefined) {
    	console.warn("Invalid data: Expected an array but got something else.");
    }

	console.log("orderString", orderString);
        return orderString;
    };

    const addNewLog = (action, warnings = "", errors = "", msg = {}) => {
        const orders = processOrders(msg);
        const status = errors && errors.length > 0 ? 'error' : warnings && warnings.length > 0 ? 'warning' : 'success';
        fetchWithAuth(`${BASE_URL}/api/log/`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ action, orders, warnings: warnings || "", errors: errors || "", status }),
        }).catch(err => console.error('Failed to write log:', err));
    };

    const getApiEndpoint = (basePath = "/api/orders/") => {
    	if (userGroups.includes("visitors")) return `${BASE_URL}/api/visitor/`;
    	if (userGroups.includes("admins")) return `${BASE_URL}/api/orders/`;
    	return `${BASE_URL}${basePath}`;  // Default to orders if no specific group found
    };

    // execute when orders data change
    const refreshOrders = () => {
        const apiEndpoint = getApiEndpoint();
        console.log("📢 Fetching orders from:", apiEndpoint);  // Debug log

        const token = getCookie('access_token');
        if (!token) {
            window.location.href = '/login';
            return;
        }

        fetchWithAuth(apiEndpoint, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then((res) => {
                if (res.status === 401) {
                    deleteCookie('access_token');
                    window.location.href = '/login';
                    return;
                }
                return res.json();
            })
            .then((data) => {
                if (data && data.length > 0) {
                    setOrders(data);
                }
            })
            .catch((error) => console.log(error));
    };

    useEffect(() => {
        if (userGroups.length > 0) {
            refreshOrders();
        }
    }, [userGroups]);

    return (
        <UserContext.Provider value={{ orders, setOrders, refreshOrders, addNewLog, userGroups, username, fetchWithAuth, getApiEndpoint }}>
            {children}
        </UserContext.Provider>
    );
};

export const useUser = () => useContext(UserContext);
